<template>
<nav
  id="site-navigation"
  class="gbwapps-nav has-branding main-navigation nav-align-right"
  aria-label="Primary"
  itemtype="https://schema.org/SiteNavigationElement"
  itemscope
>
  <div class="inside-navigation nav-shell">
    <div class="navigation-branding brand">
      <div class="site-logo">
        <router-link to="/" title="GBWApps" rel="home">
          <img class="header-image is-logo-image brand-logo" alt="GB WhatsApp" src="@/assets/logo.png" title="GBWApps">
        </router-link>
      </div>
      <p class="main-title brand-name" itemprop="headline">
        <router-link to="/" rel="home">GBWApps</router-link>
      </p>
    </div>

    <button
      type="button"
      class="menu-toggle"
      aria-label="Toggle menu"
      :aria-expanded="isMenuClicked ? 'true' : 'false'"
      @click="isMenuClicked = !isMenuClicked"
    >
      <img src="@/assets/menu.svg" alt="" v-if="!isMenuClicked">
      <img src="@/assets/xmark-black.svg" alt="" v-else>
    </button>

    <div class="main-nav">
      <ul class="menu sf-menu nav-links" :class="{ 'is-open': isMenuClicked }">
        <li
          v-for="item in navItems"
          :key="item.href"
          class="menu-item"
        >
          <router-link
            :to="item.href"
            :class="{ 'nav-download-btn': item.label === 'Download' }"
            @click.native="isMenuClicked = false"
          >{{ item.label }}</router-link>
        </li>
      </ul>
    </div>
  </div>
</nav>
</template>

<script>
export default {
  props: {
    selectedLanguage: {
      type: String,
      default: 'en',
    },
    page: {
      type: String,
      default: 'gb',
    },
    gotodownload: {
      type: Function,
      default: null,
    },
    apk: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isMenuClicked: false,
      navItems: [
        { label: 'Home', href: '/' },
        { label: 'Download', href: '/download/' },
        { label: 'Blue WhatsApp', href: '/blue-whatsapp-plus-apk/' },
        { label: 'Fouad WhatsApp', href: '/fouad-whatsapp-apk/' },
        { label: 'Aero WhatsApp', href: '/aerowhatsapp-apk/' },
        { label: 'Old Version', href: '/gbwhatsapp-old-version-apk/' },
      ],
    };
  },
  watch: {
    $route() {
      this.isMenuClicked = false;
    },
  },
};
</script>
